module.exports = __webpack_public_path__ + "img/src/components/Home/SliderAnimation/arrow-down.png?a4ba173f";